/** Parse SSE frames incrementally; JSON is checked at the client boundary. */
export class AgentStreamParser {
  private buffer = '';

  push(chunk: string): unknown[] {
    this.buffer += chunk;
    if (this.buffer.length > 2_000_000) throw new Error('Agent event exceeds the supported size.');
    const events: unknown[] = [];
    let match: RegExpExecArray | null;
    while ((match = /\r?\n\r?\n/.exec(this.buffer))) {
      const frame = this.buffer.slice(0, match.index);
      this.buffer = this.buffer.slice(match.index + match[0].length);
      const data = frame.split(/\r?\n/).filter(line => line.startsWith('data:'))
        .map(line => line.slice(5).replace(/^ /, '')).join('\n');
      if (data) events.push(JSON.parse(data));
    }
    return events;
  }

  finish(): void {
    if (this.buffer.trim()) throw new Error('The agent response was interrupted.');
  }
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}
